import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { setBackHandler, setHeaderTitle } from '../../../helpers/header.helper';
import setToast from '../../../helpers/toaster.helper';
import { AlertInfoIcon, BirdLogo, IntegrationIcon, SlackCircleSmallIcon, SlackIntRectIcon } from '../../../icon';
import { IntegrationSetupService } from '../../../services/IntegrationSetup';
import { UserService } from '../../../services/UserService';
import { AppRoutes, TeamsRoutes } from '../../routes/route.path';
import ButtonComponent from '../../shared/button/button.component';
import { buttonLabels, pageTitles } from '../../shared/constants';
import { ToasterType } from '../../shared/toaster/toaster.model';
import IntegrateSlackChannels from './integrate';
import Config from '../../../config';
import { useSelector } from 'react-redux';
import * as selectors from '../../../selectors/selectors'
import { app, authentication } from "@microsoft/teams-js";

type Props = {}

interface ConsentModal {
    orgId: string;
    name: string;
    integrationCode: string;
    integrationStatus: boolean;
}

const SlackChannelSetup = (props: Props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const IsTeamsApp: boolean = useSelector(selectors.isTeamsApp)
    const [status, setStatus] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false);

    const setIntegrationStatus = (data: ConsentModal) => {
        setLoading(true)
        IntegrationSetupService.updateIntegrationStatus(data)
            .then((res) => {
                if (status) {
                    setStatus(false);
                    setLoading(false);
                    navigate(AppRoutes.SLACK)
                    setToast("Disconnected sucessfully", ToasterType.SUCCESS);
                }
                else {
                    setStatus(true);
                    setLoading(false);
                    navigate(AppRoutes.SLACK + `?connection=true`)
                }
            })
            .catch((err) => {
                setStatus(false)
                setLoading(false)
            })
    }

    useEffect(() => {
        let params = new URLSearchParams(location.search);
        setLoading(true);
        if (params.get('connection') === 'true') {
            setStatus(true)
            setLoading(false);
        }
        else if (!!params.get('code')) {
            setIntegrationStatus({
                orgId: UserService.getCurrentUserOrgId(),
                name: "Slack",
                integrationCode: IntegrationSetupService.Slack,
                integrationStatus: !!params.get('code')
            })
            IntegrationSetupService.installSlack({
                orgId: UserService.getCurrentUserOrgId(),
                authCode: params.get('code')
            }).then((res) => {
                setToast("Integrated sucessfully", ToasterType.SUCCESS);
            }).catch((err) => {
                setToast(err.response?.data?.message, ToasterType.DANGER);

            })
        }
        else if (!!params.get('error')) {
            IntegrationSetupService.getAllIntegrations(UserService.getCurrentUserOrgId()).then(res => {
                let status = res.data?.find(x => x.integrationCode === "SLACK")?.integrationStatus ?? false
                setStatus(status);
                setLoading(false);
                status && navigate(AppRoutes.SLACK + `?connection=true`)
            }).catch(() => {
                setStatus(false)
                setLoading(false);
            })
        }
        else {
            setStatus(false);
            setLoading(false);
        }
    }, [])

    useEffect(() => {
        setHeaderTitle(pageTitles.SLACK);
        setBackHandler(() => navigate(AppRoutes.INTEGRATIIONS))
    }, [])

    const handleClick = () => {
        app.initialize()
        authentication.authenticate({
            url: TeamsRoutes.SLACK_POPUP,
            width: 800,
            height: 600,
            successCallback: (result) => {
                navigate(AppRoutes.SLACK + `?connection=${true}`)
                setStatus(true)
            },
            failureCallback: (reason) => {
                console.error('Authentication failed:', reason);
            }
        })
    }

    return (
        <div className='d-flex w-p-100 h-p-100 '>
            <div className="d-flex flex-direction w-fill h-p-100 mx-2 br-5 integrate-card-border">
                <div className={`d-flex flex-direction bg-color-integrate-ms-teams-header brt-5 ${status ? "h-p-20" : "h-p-30"}`} >
                    <div className='d-flex  align-center h-15 justify-between mx-auto mx-3'>
                        <div className='d-flex align-center'>
                            <span className=""><SlackIntRectIcon /></span>
                            <span className="mx-2"><IntegrationIcon /></span>
                            <span className="mx-2"><BirdLogo /></span>
                        </div>
                        <div className="d-flex my-auto ">
                            {!status ?
                                <div className="c-pointer mx-auto h4-regular bg-color-secondary  px-2 br-2 integrate-card-border">
                                    {
                                        IsTeamsApp ?
                                            <div onClick={handleClick} className='d-flex py-1 align-center'>
                                                <SlackCircleSmallIcon width={25} height={25} />
                                                <div className='ml-1'>Add to Slack</div>
                                            </div>
                                            : <a href={`https://slack.com/oauth/v2/authorize?client_id=${Config.SLACK_APP_CLIENT_ID}&scope=app_mentions:read,channels:history,channels:join,channels:read,chat:write,commands,files:read,files:write,groups:history,im:history,im:write,incoming-webhook,mpim:history,reactions:write&user_scope=`}>
                                                <div className='d-flex align-center justify-center py-1'>
                                                    <SlackCircleSmallIcon width={25} height={25} />
                                                    <div className='ml-1'>Add to Slack</div>
                                                </div>
                                            </a>
                                    }

                                </div>
                                :
                                <ButtonComponent Variant={"danger-btn"}
                                    OnClick={() => setIntegrationStatus({
                                        orgId: UserService.getCurrentUserOrgId(),
                                        name: "Slack",
                                        integrationCode: IntegrationSetupService.Slack,
                                        integrationStatus: false
                                    })}
                                    Type="button"
                                    ButtonLabel={loading ? "" : buttonLabels.DISCONNECT}
                                    Loading={loading}
                                />}
                        </div>
                    </div>
                    <div className='d-flex align-center bg-color-integration-info-bg ml-3 py-1 px-2 br-5 mx-auto'>
                        <AlertInfoIcon />
                        <div className='h6-regular ml-1'>
                            Messages received in an inbox will appear in the Slack channel you specify. Channel members can reply to the message from Slack.
                        </div>
                    </div>
                </div>
                <div className={`d-flex  flex-direction w-p-100 ${status ? "h-p-80" : "h-p-70"}`}>
                    <IntegrateSlackChannels isIntegrationSuccess={status} HandleClick={handleClick} />
                </div>
            </div>
        </div>
    )
}

export default SlackChannelSetup